//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { useTheme } from '@mui/material/styles';
import CopyButton from '@/components/Buttons/CopyButton';

interface CodeBlockProps {
  children?: string;
}

const CodeBlock = ({ children }: CodeBlockProps) => {
  const theme = useTheme();

  return (
    <div style={{ position: 'relative', background: theme.palette.chatbot.code, padding: '16px', borderRadius: '8px' }}>
      <pre style={{ overflow: 'auto' }}>
        <code>{children}</code>
      </pre>
      <div
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
        }}
      >
        <CopyButton textToCopy={children ?? ''} displayName="Code block" captionBelow={false} size="small" />
      </div>
    </div>
  );
};

export default CodeBlock;
